<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import { fetchTags } from './tags';

  const dispatch = createEventDispatcher();

  let tags = [];

  onMount(async () => {
    tags = await fetchTags();
  });

  function onClickClose() {
    dispatch('close');
  }

  async function onClickRefresh() {
    tags = await fetchTags(true);
  }
</script>

<div class="main">
  <header>
    <div>Tags</div>
    <div>
      <button on:click={onClickClose}>✖︎</button>
    </div>
  </header>
  <div class="buttons">
    <button on:click={onClickRefresh}>refresh</button>
  </div>
  <div class="tags">
    {#each tags as tag}
      <div class="tag">
        <span class="name">{tag.tag}</span>
        <span class="count">{tag.count}</span>
      </div>
    {/each}
  </div>
</div>

<style>
  .main {
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 1.5rem;
    top:  1.5rem;
    bottom: 1.5rem;
    right: 1.5rem;
    background-color: white;
    border: 2px solid lightgray;
    border-radius: 0.25rem;
    box-shadow: 0rem 0rem 1rem rgba(0, 0, 0, 0.25);
  }

  header {
    background-color: rgb(177, 177, 177);
    color: white;
    font-weight: bold;
    padding: 0.25rem;
    display: flex;
  }

  header div:first-child {
    flex: 2;
  }

  header button {
    font-size: 0.75rem;
  }

  .buttons {
    padding: 0.125rem;
  }

  .buttons button {
    margin: 0.125rem;
  }

  .tags {
    overflow: auto;
    padding: 0.125rem;
    display: flex;
    flex-direction: column;
  }

  .tag {
    margin: 0.125rem;
  }

  .tag .name {
    font-size: 0.8rem;
  }

  .tag .count {
    font-size: 0.5rem;
    color: gray;
  }
</style>
